import { render } from "./marquee-text.vue?vue&type=template&id=5f2e9779&scoped=true&ts=true"
import script from "./marquee-text.vue?vue&type=script&lang=ts"
export * from "./marquee-text.vue?vue&type=script&lang=ts"

import "./marquee-text.vue?vue&type=style&index=0&id=5f2e9779&scoped=true&lang=css"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2e9779"]])

export default __exports__